import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntlModule } from '@progress/kendo-angular-intl';

import { SchedulerNavigationComponent } from './scheduler-navigation.component';
import { TranslationModule } from '../translation/translation.module';

@NgModule({
    imports: [
        CommonModule,
        IntlModule,
        TranslationModule
    ],
    declarations: [SchedulerNavigationComponent],
    exports: [SchedulerNavigationComponent]
})
export class SchedulerNavigationModule { }
